import { useMemo } from "react";
import { useSelector } from "react-redux";

function usePrivilege() {
  const profileInfo = useSelector((store: any) => store.profileInfo);

  const has = (privilegeKey: any) => {
    let result = profileInfo?.privilege?.indexOf(privilegeKey) > -1 ? true : false;
    return result;
  }

  const hasNot = (privilegeKey: any) => {
    return !has(privilegeKey);
  }

  return {
    has: has,
    hasNot: hasNot,
  };
}

export { usePrivilege };